import {JobReminderNotificationDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";

/**
 * Job reminder notification class data.
 */
export default class JobReminderNotificationData {
	/**
	 * @param {string} content Note content.
	 * @param {string} jobId Job Id which was noted.
	 * @param {string} noteId Note Id.
	 * @param {string} referenceNumber
	 * @param {string} creator Note creator.
	 */
	constructor(readonly content: string,
		readonly jobId: string,
		readonly noteId: string,
		readonly referenceNumber: string,
		public readonly creator: AuthenticatedEntity) {}

	static fromJson(json: JobReminderNotificationDataApiDto): JobReminderNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new JobReminderNotificationData(json.text, json.jobId, json.noteId, json.referenceNumber, creator);
	}


	getJobReferenceNumber() {
		return this.referenceNumber
	}
}
